import { BulkScrapSource, BulkScrapStatus } from '../../services/bulk-scrap-request.service';

export interface BadgeMeta {
  label: string;
  badgeClass: string;
}

/** Exhaustive: adding a status to BULK_SCRAP_STATUSES fails the build until it is styled here. */
export const BULK_SCRAP_STATUS_META: Record<BulkScrapStatus, BadgeMeta> = {
  Submitted: { label: 'Submitted', badgeClass: 'bg-blue-100 text-blue-800 border-blue-200' },
  Contacted: { label: 'Contacted', badgeClass: 'bg-amber-100 text-amber-800 border-amber-200' },
  UnderReview: { label: 'Under review', badgeClass: 'bg-purple-100 text-purple-800 border-purple-200' },
  Quoted: { label: 'Quoted', badgeClass: 'bg-cyan-100 text-cyan-800 border-cyan-200' },
  Scheduled: { label: 'Scheduled', badgeClass: 'bg-indigo-100 text-indigo-800 border-indigo-200' },
  Completed: { label: 'Completed', badgeClass: 'bg-green-100 text-green-800 border-green-200' },
  Cancelled: { label: 'Cancelled', badgeClass: 'bg-red-100 text-red-800 border-red-200' },
};

/** Exhaustive: the API only accepts these sources, so there is no "unknown" case. */
export const BULK_SCRAP_SOURCE_META: Record<BulkScrapSource, BadgeMeta> = {
  iOS: { label: 'iOS', badgeClass: 'bg-slate-100 text-slate-700' },
  Android: { label: 'Android', badgeClass: 'bg-emerald-100 text-emerald-800' },
  WebApp: { label: 'Web', badgeClass: 'bg-indigo-100 text-indigo-800' },
  ControlCenter: { label: 'Control Center', badgeClass: 'bg-orange-100 text-orange-800' },
  WhatsApp: { label: 'WhatsApp', badgeClass: 'bg-lime-100 text-lime-800' },
  MobileApp: { label: 'Mobile App', badgeClass: 'bg-sky-100 text-sky-800' },
};
